module.exports = __webpack_public_path__ + "img/About_content_Graph1.2140a2d9.png";